module.exports = __webpack_public_path__ + "0a86d5d8803cceed51af3a4bf4969790.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201604_Presse_AVANGA_Sputnika_556KB.jpg
// module id = 566
// module chunks = 0